import React from 'react'

const ModuleDisplayText = ({ value }) => {
    return (
        <>{value}</>
    )
}

export default ModuleDisplayText